import {
  ChartCurve,
  ChartShape
} from '@base/@types/components/Layout/Graphic/Info'
import { IGraphicMarginOrSales } from '@base/@types/providers/Kpi/SalesProvider'

enum SalesOrMarginType {
  accumulated = '1',
  monthToMonth = '2'
}

export const getSalesSeries = (
  marginOrSales: IGraphicMarginOrSales[],
  salesType: string
) => {
  return [
    {
      name: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === salesType
                  ? 'Vendas Anterior Acumulado'
                  : 'Vendas Anterior'
              }`
          )?.nome
        : '',
      type: 'column',
      data: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === salesType
                  ? 'Vendas Anterior Acumulado'
                  : 'Vendas Anterior'
              }`
          )?.valores
        : []
    },
    {
      name: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === salesType
                  ? 'Vendas Atual Acumulado'
                  : 'Vendas Atual'
              }`
          )?.nome
        : '',
      type: 'column',
      data: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === salesType
                  ? 'Vendas Atual Acumulado'
                  : 'Vendas Atual'
              }`
          )?.valores
        : []
    },
    {
      name: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === salesType
                  ? 'Vendas Orçado Acumulado'
                  : 'Vendas Orçado'
              }`
          )?.nome
        : '',
      type: 'column',
      data: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === salesType
                  ? 'Vendas Orçado Acumulado'
                  : 'Vendas Orçado'
              }`
          )?.valores
        : []
    }
  ]
}

export const salesOptions = {
  chart: {
    dropShadow: {
      enabled: true,
      color: '#000',
      top: -1,
      left: 1,
      blur: 1,
      opacity: 0.1
    },
    toolbar: {
      show: true,
      offsetY: 5,
      offsetX: -12
    }
  },
  colors: ['#7fb187', '#60b2ba', '#d0a343'],
  plotOptions: {
    bar: {
      columnWidth: '55%'
    }
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    show: true,
    width: [2, 2, 2],
    curve: ChartCurve.smooth,
    colors: ['transparent', 'transparent', 'transparent']
  },
  xaxis: {
    categories: [
      'JAN',
      'FEV',
      'MAR',
      'ABR',
      'MAI',
      'JUN',
      'JUL',
      'AGO',
      'SET',
      'OUT',
      'NOV',
      'DEZ'
    ]
  },
  markers: {
    size: 1
  },
  yaxis: [
    {
      title: {
        text: 'R$'
      },
      labels: {
        formatter: function (val: number) {
          if (val === 0) {
            return '0'
          }
          return val / 10000000 + 'M'
        }
      },
      tickAmount: 4
    }
  ],
  tooltip: {
    shared: true,
    y: {
      formatter: function (y: any) {
        if (typeof y !== 'undefined') {
          return Number(y / 10000000).toFixed(2) + 'M'
        }
        return y
      }
    }
  }
}

export const getMarginSeries = (
  marginOrSales: IGraphicMarginOrSales[],
  marginType: string
) => {
  return [
    {
      name: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === marginType
                  ? 'Margem Anterior Acumulado'
                  : 'Margem Anterior'
              }`
          )?.nome
        : '',
      type: 'column',
      data: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === marginType
                  ? 'Margem Anterior Acumulado'
                  : 'Margem Anterior'
              }`
          )?.valores
        : []
    },
    {
      name: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === marginType
                  ? 'Margem Atual Acumulado'
                  : 'Margem Atual'
              }`
          )?.nome
        : '',
      type: 'column',
      data: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === marginType
                  ? 'Margem Atual Acumulado'
                  : 'Margem Atual'
              }`
          )?.valores
        : []
    },
    {
      name: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === marginType
                  ? 'Margem Orçado Acumulado'
                  : 'Margem Orçado'
              }`
          )?.nome
        : '',
      type: 'column',
      data: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === marginType
                  ? 'Margem Orçado Acumulado'
                  : 'Margem Orçado'
              }`
          )?.valores
        : []
    },
    {
      name: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === marginType
                  ? 'Margem Percentual Anterior Acumulada'
                  : 'Margem Percentual Anterior'
              }`
          )?.nome
        : '',
      type: 'line',
      data: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === marginType
                  ? 'Margem Percentual Anterior Acumulada'
                  : 'Margem Percentual Anterior'
              }`
          )?.valores
        : []
    },
    {
      name: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === marginType
                  ? 'Margem Percentual Atual Acumulada'
                  : 'Margem Percentual Atual'
              }`
          )?.nome
        : '',
      type: 'line',
      data: marginOrSales
        ? marginOrSales.find(
            item =>
              item.descricao ===
              `${
                SalesOrMarginType.accumulated === marginType
                  ? 'Margem Percentual Atual Acumulada'
                  : 'Margem Percentual Atual'
              }`
          )?.valores
        : []
    }
  ]
}

export const marginOptions = {
  chart: {
    dropShadow: {
      enabled: true,
      color: '#000',
      top: -1,
      left: 1,
      blur: 1,
      opacity: 0.1
    },
    toolbar: {
      show: true,
      offsetY: 5,
      offsetX: -75
    }
  },
  colors: ['#7fb187', '#60b2ba', '#d0a343', '#21259b', '#0b5e16'],
  plotOptions: {
    bar: {
      columnWidth: '65%'
    }
  },
  stroke: {
    show: true,
    width: [2, 2, 2, 2, 2],
    curve: ChartCurve.smooth,
    colors: ['transparent', 'transparent', 'transparent', '#21259b', '#0b5e16']
  },
  markers: {
    size: 3,
    strokeWidth: 0,
    shape: ChartShape.circle,
    hover: {
      size: 6
    }
  },
  xaxis: {
    categories: [
      'JAN',
      'FEV',
      'MAR',
      'ABR',
      'MAI',
      'JUN',
      'JUL',
      'AGO',
      'SET',
      'OUT',
      'NOV',
      'DEZ'
    ]
  },
  yaxis: [
    {
      opposite: false,
      labels: {
        show: false
      }
    },
    {
      opposite: false,
      labels: {
        show: false
      }
    },
    {
      opposite: false,
      tickAmount: 5,
      title: {
        text: 'R$'
      },
      labels: {
        formatter: function (val: any) {
          if (val === 0) {
            return '0'
          }
          return val / 100000 + 'K'
        }
      }
    },
    {
      opposite: true,
      tickAmount: 6,
      labels: {
        show: false
      },
      min: 25,
      max: 40
    },
    {
      opposite: true,
      tickAmount: 6,
      title: {
        text: '%'
      },
      labels: {
        formatter: function (val: any) {
          return val
        }
      },
      min: 25,
      max: 40
    }
  ],
  tooltip: {
    shared: true,
    intersect: false,
    y: [
      {
        formatter: function (y: any) {
          if (typeof y !== 'undefined') {
            return Number(y / 100000).toFixed(2) + 'K'
          }
          return y
        }
      },
      {
        formatter: function (y: any) {
          if (typeof y !== 'undefined') {
            return Number(y / 100000).toFixed(2) + 'K'
          }
          return y
        }
      },
      {
        formatter: function (y: any) {
          if (typeof y !== 'undefined') {
            return Number(y / 100000).toFixed(2) + 'K'
          }
          return y
        }
      },
      {
        formatter: function (y: any) {
          if (typeof y !== 'undefined') {
            return y.toFixed(2) + '%'
          }
          return y
        }
      },
      {
        formatter: function (y: any) {
          if (typeof y !== 'undefined') {
            return y.toFixed(2) + '%'
          }
          return y
        }
      }
    ]
  }
}
